export const FUNNEL_TRUST_PILOT = "trust-pilot" as const;
export type FunnelTypes = typeof FUNNEL_TRUST_PILOT;
